export const CONFIG_MANIFEST = {
  sharks: {
    selachii: "selachii.config.js",
    galeomorphii: "galeomorphii.config.js",
    squalomorphii: "squalomorphii.config.js",
    squaliformes: "squaliformes.config.js",
    carcharhiniformes: "carcharhiniformes.config.js",
    orectolobiformes: "orectolobiformes.config.js",
    lamniformes: "lamniformes.config.js",
    hexanchiformes: "hexanchiformes.config.js",
    squatiniformes: "squatiniformes.config.js",
    heterodontiformes: "heterodontiformes.config.js",
    pristiophoriformes: "pristiophoriformes.config.js",
    carcharhinidae: "carcharhinidae.config.js",
    lamnidae: "lamnidae.config.js",
    scyliorhinidaeI: "scyliorhinidae.i.config.js",
    scyliorhinidaeII: "scyliorhinidae.ii.config.js",
    scyliorhinidaeIII: "scyliorhinidae.iii.config.js",
    dalatiidae: "dalatiidae.config.js",
    etmopteridae: "etmopteridae.config.js",
    squalidae: "squalidae.config.js",
    triakidae: "triakidae.config.js",
    centrophoridae: "centrophoridae.config.js",
    echinorhinidae: "echinorhinidae.config.js",
    hemigaleidae: "hemigaleidae.config.js",
    hemiscylliidae: "hemiscylliidae.config.js",
    orectolobidae: "orectolobidae.config.js",
    somniosidaeOxynotidae: "somniosidae-oxynotidae.config.js",
    sphyrnidae: "sphyrnidae.config.js"
  },
  rays: {
    batomorphi: "batomorphi.config.js",
    arhynchobatidae: "arhynchobatidae.config.js",
    dasyatidae: "dasyatidae.config.js",
    gymnuridae: "gymnuridae.config.js",
    mobulidae: "mobulidae.config.js",
    myliobatidae: "myliobatidae.config.js",
    myliobatiformes: "myliobatiformes.config.js",
    platyrhinidae: "platyrhinidae.config.js",
    rajidae: "rajidae.config.js",
    rajiformes: "rajiformes.config.js",
    rhinopristiformes: "rhinopristiformes.config.js",
    rhinopteridae: "rhinopteridae.config.js",
    torpediniformes: "torpediniformes.config.js",
    urolophus: "urolophus.config.js",
    urotrygonidae: "urotrygonidae.config.js"
  },
  chimaeras: {
    callorhinchidae: "callorhinchidae.config.js",
    chimaeiridae: "chimaeiridae.config.js",
    holocephali: "holocephali.config.js",
    rhinochimaeridae: "rhinochimaeridae.config.js"
  }
};
